import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack, IoShieldCheckmarkOutline } from 'react-icons/io5';
import { useLanguage } from './contexts/LanguageContext';
import './PrivacyPage.css';

function PrivacyPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="legal-container">
      <div className="legal-header">
        <button className="back-button" onClick={handleBack}>
          <IoArrowBack size={20} />
          {t('back')}
        </button>
        <div className="header-content">
          <IoShieldCheckmarkOutline size={48} style={{ marginBottom: '12px', opacity: 0.9 }} />
          <h1>{t('privacyTitle')}</h1>
          <p>{t('privacyLastUpdated')}</p>
        </div>
      </div>

      <div className="legal-content">
        <div className="legal-card">

          <section className="legal-section">
            <h2>{t('privacyIntroTitle')}</h2>
            <p>{t('privacyIntroText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacyCollectTitle')}</h2>

            <h3>{t('privacyAccountTitle')}</h3>
            <ul>
              <li>{t('privacyAccountEmail')}</li>
              <li>{t('privacyAccountName')}</li>
              <li>{t('privacyAccountAuth')}</li>
            </ul>

            <h3>{t('privacyLocationTitle')}</h3>
            <ul>
              <li>{t('privacyLocationDesc')}</li>
              <li>{t('privacyLocationWhen')}</li>
              <li>{t('privacyLocationNoTrack')}</li>
            </ul>

            <h3>{t('privacyDeviceTitle')}</h3>
            <ul>
              <li>{t('privacyDeviceToken')}</li>
              <li>{t('privacyDeviceType')}</li>
              <li>{t('privacyDeviceLang')}</li>
            </ul>

            <h3>{t('privacyUsageTitle')}</h3>
            <ul>
              <li>{t('privacyUsageWatch')}</li>
              <li>{t('privacyUsageNotif')}</li>
              <li>{t('privacyUsagePrefs')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('privacyHowUseTitle')}</h2>
            <ul>
              <li>{t('privacyHowUseNearby')}</li>
              <li>{t('privacyHowUseNotifs')}</li>
              <li>{t('privacyHowUseAuth')}</li>
              <li>{t('privacyHowUseSub')}</li>
              <li>{t('privacyHowUseImprove')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('privacyThirdPartyTitle')}</h2>
            <p>{t('privacyThirdPartyIntro')}</p>
            <ul>
              <li><strong>Firebase (Google)</strong> — {t('privacyThirdFirebase')}</li>
              <li><strong>RevenueCat</strong> — {t('privacyThirdRevenueCat')}</li>
              <li><strong>Apple/Google Maps</strong> — {t('privacyThirdMaps')}</li>
            </ul>
            <p>{t('privacyThirdPartyNote')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacyNoSellTitle')}</h2>
            <p>{t('privacyNoSellText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacyRetentionTitle')}</h2>
            <p>{t('privacyRetentionText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacyRightsTitle')}</h2>
            <p>{t('privacyRightsIntro')}</p>
            <ul>
              <li>{t('privacyRightsAccess')}</li>
              <li>{t('privacyRightsDelete')}</li>
              <li>{t('privacyRightsExport')}</li>
              <li>{t('privacyRightsOptOut')}</li>
            </ul>
            <p>{t('privacyRightsHow')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacyChildrenTitle')}</h2>
            <p>{t('privacyChildrenText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacyChangesTitle')}</h2>
            <p>{t('privacyChangesText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacyContactTitle')}</h2>
            <p>{t('privacyContactText')}</p>
            <p className="contact-email">support@noqueuecharge.com</p>
          </section>

        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
